import { render, staticRenderFns } from "./global-category-widget.vue?vue&type=template&id=dfb84cc2&"
import script from "./global-category-widget.vue?vue&type=script&lang=js&"
export * from "./global-category-widget.vue?vue&type=script&lang=js&"
import style0 from "./global-category-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports